module.exports = __webpack_public_path__ + "img/houbg.8429d4af.jpg";